import CFDIArticulo69B from 'components/Invoices/CFDIArticulo69B/CFDIArticulo69B'
import CFDIMovement from 'components/Invoices/CFDIMovement/CFDIMovement'
import CFDIPaymentStatus from 'components/Invoices/CFDIPaymentStatus/CFDIPaymentStatus'
import CFDIStatus from 'components/Invoices/CFDIStatus/CFDIStatus'
import {
  convertJsonArrayToCSV,
  downloadFileFromData,
} from 'lib/helpers/utilities'
import {
  getFormattedSerieFolio,
  getInvoiceFormattedCurrency,
  getInvoiceFormattedDate,
  getInvoiceFormattedTime,
} from 'lib/utils/Invoices/invoices.utils'
import { UnparsedClient } from 'models/client'
import { IInvoice } from 'models/invoices.models'

interface IUseDownloadInvoicesCsv {
  onDownloadCsv: (list: IInvoice[]) => void
}

const useDownloadInvoicesCsv = (): IUseDownloadInvoicesCsv => {
  const csvConfiguration = [
    {
      accesor: 'createdAt',
      label: 'Fecha',
      formatter: getInvoiceFormattedDate,
    },
    { accesor: 'createdAt', label: 'Hora', formatter: getInvoiceFormattedTime },
    { accesor: 'uuid', label: 'UUID' },
    {
      accesor: 'serie',
      label: 'Serie/Folio',
      formatter: getFormattedSerieFolio,
    },
    { accesor: 'clients.rfc', label: 'RFC Receptor' },
    { accesor: 'clients.bussinessName', label: 'Nombre Receptor' },
    { accesor: 'emisor.rfc', label: 'RFC Emisor' },
    { accesor: 'emisor.name', label: 'Nombre Emisor' },
    {
      accesor: 'movementType',
      label: 'Tipo',
      formatter: (st: string, row: any) => (
        <CFDIMovement type={st} addTooltip={false} returnLabel />
      ),
    },
    {
      accesor: 'status',
      label: 'Estatus',
      formatter: (st: number, row: any) => (
        <CFDIStatus status={st} row={row} addTooltip={false} returnLabel />
      ),
    },
    {
      accesor: 'clients',
      label: 'Art. 69B',
      formatter: (st: UnparsedClient, row: any) => (
        <CFDIArticulo69B receptor={st} addTooltip={false} returnLabel />
      ),
    },
    {
      accesor: 'statusPayment',
      label: 'Pago',
      formatter: (st: number, row: any) => (
        <CFDIPaymentStatus
          status={st}
          row={row}
          addTooltip={false}
          returnLabel
        />
      ),
    },
    {
      accesor: 'subtotal',
      label: 'Subtotal',
      formatter: getInvoiceFormattedCurrency,
    },
    {
      accesor: 'taxes',
      label: 'Impuestos',
      formatter: getInvoiceFormattedCurrency,
    },
    {
      accesor: 'total',
      label: 'Total',
      formatter: getInvoiceFormattedCurrency,
    },
  ]

  const onDownloadCsv = (list: IInvoice[]) => {
    const headers = csvConfiguration.map(({ label }) => label)
    const rows = convertJsonArrayToCSV<IInvoice>(csvConfiguration, list)
    const csvContent = `data:text/csv;charset=utf-8,${headers.join(',')}\n${rows.map((e: any) => e.join(',')).join('\n')}`
    const encodedUri = encodeURI(csvContent)
    downloadFileFromData('lista_cfdis.csv', encodedUri)
  }

  return {
    onDownloadCsv,
  }
}

export default useDownloadInvoicesCsv
